import type { AreaUnit } from './types'

// Harvest weights: pounds for an imperial org, kilograms for a metric one, with the other beside it.
const KG_PER_LB = 0.45359237

export type MassUnit = 'lb' | 'kg'

/** The weight unit that goes with the org's area unit (acres → lb, hectares → kg). */
export const massUnitFor = (areaUnit: AreaUnit): MassUnit => (areaUnit === 'acre' ? 'lb' : 'kg')

/** A weight in the other common unit: lb → kg, kg → lb. Null for any other unit. */
export function otherMass(quantity: number, unit: string): { quantity: number; unit: MassUnit } | null {
  const u = unit.trim().toLowerCase()
  if (u === 'lb' || u === 'lbs') return { quantity: quantity * KG_PER_LB, unit: 'kg' }
  if (u === 'kg' || u === 'kgs') return { quantity: quantity / KG_PER_LB, unit: 'lb' }
  return null
}

/** "≈ 181 kg", or null when the unit has no lb/kg counterpart or the amount is blank. */
export function otherMassLabel(quantity: number | undefined, unit: string): string | null {
  if (quantity == null || !(quantity > 0)) return null
  const other = otherMass(quantity, unit)
  if (!other) return null
  const digits = other.quantity < 10 ? 1 : 0
  return `≈ ${other.quantity.toLocaleString('en-CA', { maximumFractionDigits: digits })} ${other.unit}`
}
